<template>
  <div class="m-document-create-edit">
    <b-modal
      id="documents-create-edit-document-modal"
      v-model="localActive"
      size="custom-size"
      no-enforce-focus
      centered
      hide-footer
      hide-header
      @show="onShowModal"
      @close="closeModal"
    >
      <svg
        class="m-document-create-edit-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="closeModal"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="m-document-create-edit-title">
        <div>
          {{ modalTitle }}
          <span v-if="modalInfo.isEdit" class="updating-analyse-label">
            {{ updatingAnalyseLabel }}
          </span>
        </div>
      </div>
      <div class="position-relative">
        <div id="m-document-create-edit-content-shadow-top" class="m-document-create-edit-content-shadow-top"></div>
        <div
          id="m-document-create-edit-content"
          class="m-document-create-edit-content"
          :class="{ 'm-document-create-edit-content-overflow': appendLocalFiles.length }"
          @scroll="setShadowsCreateEditDocumentModal"
        >
          <c-input-old
            v-if="!modalInfo.isEdit"
            v-model="selectedAnalyseType"
            :required="errorMessages.analyseType"
            :items="analysesTypes"
            :searchable="true"
            :clearable="true"
            :class="{ 'm-document-create-edit-content-select-required': errorMessages.analyseType.length }"
            class="m-document-create-edit-content-select mb-4"
            type="select"
            floating-label="Тип анализа"
          />
          <c-input-old
            v-if="!modalInfo.isEdit"
            v-model="selectedAnalyse"
            :class="{ 'm-document-create-edit-content-select-required': errorMessages.analyse.length }"
            :required="errorMessages.analyse"
            :items="analysesList"
            :searchable="true"
            :clearable="true"
            class="m-document-create-edit-content-select"
            type="select"
            floating-label="Анализ"
          />
          <c-input
            ref="createEditDocumentDate"
            v-model="dateOfAnalyse"
            :required="errorMessages.analyseDate"
            :input-text-condition="errorMessages.analyseDate"
            :icon-right="true"
            :editable="true"
            :label="modalInfo.isEdit ? 'Дата пересдачи' : 'Дата сдачи'"
            :class="{
              'm-document-create-edit-content-date-required': errorMessages.analyseDate.length > 0,
              'resend': modalInfo.isEdit,
            }"
            class="m-document-create-edit-content-date"
            type="date"
            icon="calendar"
            format="DD.MM.YYYY, dddd"
            placeholder="00.00.0000"
            @invalidDate="sendErrorDateMessage"
          />
          <c-input-old
            v-model="analyseComment"
            class="m-document-create-edit-content-textarea"
            type="textarea"
            :clearable="true"
            max-length="500"
            floating-label="Комментарий"
          />
          <viewer
            v-if="appendLocalFiles.length > 0"
            :images="appendLocalImages.map((img) => img.url)"
            class="m-document-create-edit-content-photos"
          >
            <div
              v-for="(file, index) in appendLocalFiles"
              :key="index"
              class="m-document-create-edit-content-photos-item"
            >
              <div class="d-flex flex-column align-content-center justify-content-center">
                <div
                  class="m-document-create-edit-content-photos-item-container"
                >
                  <div
                    v-if="
                      file.format === 'jpg' || file.format === 'jpeg' || file.format === 'png' || file.format === 'gif'
                    "
                    class="img-wrapper"
                  >
                    <div class="svg-wrapper">
                      <svg-icon
                        name="eye"
                        :size="32"
                        color="white"
                      ></svg-icon>
                    </div>
                    <img
                      class="m-document-create-edit-content-photos-item-photo"
                      :src="file.url"
                    />
                  </div>
                  <a
                    v-if="file.format === 'docx' || file.format === 'doc' || file.format === 'pdf'"
                    :href="file.href"
                    class="svg-wrapper docsDownload"
                    download
                    target="_blank"
                  >
                    <svg-icon name="upload-light" color="white" :size="24"></svg-icon>
                  </a>
                  <svg
                    v-if="file.format === 'docx' || file.format === 'doc'"
                    width="33"
                    height="33"
                    viewBox="0 0 33 33"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M26.8035 8.296L24.3795 25H17.9475L16.4595 13L14.8035 25H8.5155L6.1875 8.296H11.1315L12.1875 21.424L13.9635 8.296H19.1235L20.6115 21.424L22.0515 8.296H26.8035Z"
                      fill="#2B579A"
                    />
                    <path d="M1.5 31.5V1.5H31.5V31.5H1.5Z" stroke="#2B579A" stroke-width="3" />
                  </svg>
                  <svg
                    v-if="file.format === 'pdf'"
                    width="33"
                    height="33"
                    viewBox="0 0 33 33"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M1.5 31.5V1.5H31.5V31.5H1.5Z" stroke="#E30000" stroke-width="3" />
                    <path
                      d="M18.4486 14.7397C17.205 15.7354 17.1654 15.7596 16.431 16.3868C15.6967 17.014 15.4226 17.1035 14.1731 18.0923M18.4486 14.7397C22.6951 13.107 23.8297 9.49956 20.8864 8.43992C17.943 7.38027 16.3731 10.9298 18.4486 14.7397ZM18.4486 14.7397C18.7117 16.2779 18.7225 16.2654 18.8943 17.2736C19.0695 18.3012 19.0607 18.4132 19.3329 19.95M14.1731 18.0923C15.6889 18.6333 16.7871 19.0334 16.7871 19.0334C16.7871 19.0334 17.8203 19.4006 19.3329 19.95M14.1731 18.0923C10.584 15.3615 6.77769 16.2174 7.29796 19.2059C7.81822 22.1944 11.7902 21.731 14.1731 18.0923ZM19.3329 19.95C23.8993 20.1552 26.1933 23.2073 23.7703 25.1362C21.3472 27.065 18.6614 24.2047 19.3329 19.95Z"
                      stroke="#E30000"
                      stroke-width="2"
                    />
                  </svg>
                </div>
                <div class="m-document-create-edit-content-photos-item-name">{{ file.name }}</div>
              </div>
              <c-button
                v-b-popover.html="{
                  container: '#app',
                  trigger: 'hover blur',
                  content: 'Удалить',
                  placement: 'top',
                }"
                class="m-document-create-edit-content-photos-item-trash"
                size="iconic"
                icon="trash"
                @click="removeImage(index, file.name)"
              />
            </div>
          </viewer>
          <input
            id="m-write-file-upload"
            ref="writeExplanatoryFileUpload"
            name="attachment[]"
            type="file"
            accept=".doc, .docx, image/gif, image/jpeg, image/png, .pdf"
            hidden
            multiple
            @change="onFileChange"
          />
          <c-button
            :disabled="appendLocalFiles.length === 20"
            :icon="{ icon: 'plus', color: 'primary' }"
            :class="{
              'm-document-create-edit-content-add-photo-photos-not-empty': appendLocalFiles.length > 0,
              'm-document-create-edit-content-add-photo-required': isFileExceedsAllowedSize,
            }"
            class="m-document-create-edit-content-add-photo"
            label="Добавить файл"
            size="small"
            @click="chooseFiles"
          />
          <transition name="fade">
            <div v-if="isFileExceedsAllowedSize" class="m-document-create-edit-content-photos-error-message">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="7" cy="7" r="6.5" fill="white" stroke="#FF238D"></circle>
                <circle cx="7" cy="10" r="1" fill="#FF238D"></circle>
                <rect x="6" y="3" width="2" height="5" rx="1" fill="#FF238D"></rect>
              </svg>
              <div class="m-document-create-edit-content-photos-error-message-text">
                {{ isFileExceedsAllowedSize ? "Файл не может быть больше 50МБ" : "Выберите файл" }}
              </div>
            </div>
          </transition>
        </div>
        <div
          id="m-document-create-edit-content-shadow-bottom"
          class="m-document-create-edit-content-shadow-bottom"
        ></div>
      </div>
      <div class="m-document-create-edit-buttons">
        <c-button class="m-document-create-edit-buttons-cancel" label="Отменить" @click="closeModal" />
        <c-button
          class="m-document-create-edit-buttons-submit"
          color="primary"
          label="Сохранить"
          @click="submitDocument"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Input from "@/components/controls2/Input";
import InputOld from "@/components/controls/input-old";
import Button from "@/components/controls2/Button";
import SvgIcon from "@/components/svg-icon";

import { imageAllowedFormats } from "../../../../constants/imageAllowedFormats";
import { errors } from "../../../../constants/errorFieldValues";

export default {
  name: "medical-documents-create-edit-modal",
  components: {
    "c-input": Input,
    "c-input-old": InputOld,
    "c-button": Button,
    SvgIcon
  },
  props: ["active", "analyseId", "modalInfo", "attachedFiles"],
  data() {
    return {
      localActive: false,
      openFirstly: true,
      analysesList: [],

      selectedAnalyseType: null,
      selectedAnalyse: null,
      dateOfAnalyse: "",
      analyseComment: null,

      errorMessages: {
        analyseType: "",
        analyse: "",
        analyseDate: "",
        files: "",
      },

      documentLocalErrorMessage: "",
      dateLocalErrorMessage: "",
      attemptToSend: false,
      formDataFiles: [],
      isFileExceedsAllowedSize: false,

      appendLocalFiles: [],
      appendLocalImages: [],
    };
  },
  computed: {
    ...mapGetters({
      analysesTypes: "medicalAnalysesForm/getNotEmptyAnalysesTypes",
      getAnalyseTypeByAnalyseId: "medicalAnalysesForm/getAnalyseTypeByAnalyseId",
      getAnalysesByTypeId: "medicalAnalysesForm/getAnalysesByTypeId",
    }),
    modalTitle() {
      return this.modalInfo.isEdit ? "Пересдать анализ" : "Добавить анализ";
    },
    updatingAnalyseLabel() {
      return this.selectedAnalyse ? this.selectedAnalyse.label : "";
    },
  },
  watch: {
    // analyseComment(value, oldValue) {
    //   if (value.length >= 500) {
    //     this.analyseComment = oldValue
    //   }
    // },
    selectedAnalyseType(value) {
      if (!value) {
        this.selectedAnalyse = null;
        this.analysesList = [];
      }
      if (!this.openFirstly && value) {
        this.analysesList = this.getAnalysesByTypeId(this.selectedAnalyseType.value).map((item) => ({
          value: item.id,
          label: item.name,
        }));
        this.selectedAnalyse = null;
      }
      this.errorMessages.analyseType = "";
    },
    localActive(value) {
      if (!value) {
        this.formDataFiles = [];
        this.$emit("close");
        setTimeout(() => {
          this.appendLocalFiles = [];
          this.dateOfAnalyse = "";
          this.selectedAnalyseType = null;
          this.selectedAnalyse = null;
          this.analysesList = [];
          this.attemptToSend = false;
          this.analyseComment = "";
          this.errorMessages = {
            analyse: "",
            analyseType: "",
            analyseDate: "",
            files: "",
          };
          this.isFileExceedsAllowedSize = false;
          this.openFirstly = true;
        }, 250);
      }
    },
    active(value) {
      this.localActive = value;
    },
    appendLocalImages(value) {
      const viewer = document.getElementById("viewer1");
      setTimeout(() => {
        if (this.localActive && viewer) {
          if (value.length > 1) {
            viewer.classList.add("viewer-slider-create-edit-document");
          } else {
            viewer.classList.remove("viewer-slider-create-edit-document");
          }
        }
      }, 500);
    },
    selectedAnalyse() {
      this.errorMessages.analyse = "";
    },
    dateOfAnalyse(value) {
      if (value && this.errorMessages.analyseDate) {
        this.errorMessages.analyseDate = "";
      }
    },
  },
  mounted() {
    this.setShadowsCreateEditDocumentModal();
  },
  methods: {
    closeModal() {
      this.localActive = false;
    },
    onShowModal() {
      this.documentLocalItems = [];
      setTimeout(() => {
        if (this.attachedFiles) {
          this.appendLocalFiles = [];
          this.appendLocalImages = [];

          this.attachedFiles.forEach((file) => {
            const format = file.split(".").pop();
            if (imageAllowedFormats.some(format)) {
              this.appendLocalImages.push({ url: `documents/${file}`, name: file });
            }
            this.appendLocalFiles.push({ format, name: file, url: `documents/${file}` });
          });
        }
      }, 300);

      if (this.modalInfo.analyseId) {
        const fetchedAnalyseType = this.getAnalyseTypeByAnalyseId(this.modalInfo.analyseId);
        this.selectedAnalyseType = {
          value: fetchedAnalyseType.id,
          label: fetchedAnalyseType.name,
        };
        this.analysesList = this.getAnalysesByTypeId(this.selectedAnalyseType.value).map((item) => ({
          value: item.id,
          label: item.name,
        }));
        this.selectedAnalyse = this.analysesList.find((analyse) => analyse.value === this.modalInfo.analyseId);
      }

      setTimeout(() => {
        this.openFirstly = false;
      }, 0);
    },
    setShadowsCreateEditDocumentModal() {
      const shadowTopElement = document.getElementById("m-document-create-edit-content-shadow-top");
      const shadowBottomElement = document.getElementById("m-document-create-edit-content-shadow-bottom");
      const scrollableElement = document.getElementById("m-document-create-edit-content");
      if (scrollableElement !== null) {
        if (scrollableElement.scrollHeight > scrollableElement.clientHeight) {
          // top shadow items
          if (scrollableElement.scrollTop !== 0) {
            shadowTopElement.classList.add("m-document-create-edit-content-shadow-top-active");
          } else if (scrollableElement.scrollTop === 0) {
            shadowTopElement.classList.remove("m-document-create-edit-content-shadow-top-active");
          }
          // bottom shadow items
          if (scrollableElement.scrollTop + scrollableElement.clientHeight !== scrollableElement.scrollHeight) {
            shadowBottomElement.classList.add("m-document-create-edit-content-shadow-bottom-active");
          } else {
            shadowBottomElement.classList.remove("m-document-create-edit-content-shadow-bottom-active");
          }
        } else {
          shadowTopElement.classList.remove("m-document-create-edit-content-shadow-top-active");
          shadowBottomElement.classList.remove("m-document-create-edit-content-shadow-bottom-active");
        }
      }
    },
    chooseFiles() {
      document.getElementById("m-write-file-upload").click();
    },
    onFileChange(e) {
      this.isFileExceedsAllowedSize = false;
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      console.log(files);
      const newFileList = Array.from(files);
      newFileList.forEach((file, index) => {
        if (file.size > 50000000) {
          newFileList.splice(index, 1);
          this.isFileExceedsAllowedSize = true;
          return;
        }
        this.formDataFiles.push(file);
      });
      this.createImage(newFileList);
    },
    createImage(files) {
      const vm = this;
      for (let index = 0; index < files.length; index++) {
        const reader = new FileReader();
        reader.onload = (event) => {
          const { name } = files[index];
          const format = name.split(".").pop();
          const url = event.target.result;
          if (vm.appendLocalFiles.length < 20) {
            vm.appendLocalFiles.push({ url, name, format, href: URL.createObjectURL(files[index]) });
            if (imageAllowedFormats.includes(format)) {
              vm.appendLocalImages.push({ url, name });
            }
          }
        };
        reader.readAsDataURL(files[index]);
      }
    },
    sendErrorDateMessage(e) {
      if (e) this.errorMessages.analyseDate = errors.date.wrongValue;
    },
    removeImage(index, name) {
      this.appendLocalFiles.splice(index, 1);

      const c = this.appendLocalImages.findIndex((img) => img.name === name);

      if (c !== -1) this.appendLocalImages.splice(c, 1);

      const b = this.formDataFiles.findIndex((file) => file.name === name);

      if (b !== -1) this.formDataFiles.splice(b, 1);
    },
    validateForm() {
      let isFormValid = true;

      if (!this.selectedAnalyseType) {
        isFormValid = false;
        this.errorMessages.analyseType = errors.required;
      }
      if (!this.selectedAnalyse) {
        isFormValid = false;
        this.errorMessages.analyse = errors.required;
      }
      if (!this.dateOfAnalyse) {
        isFormValid = false;
        this.errorMessages.analyseDate = errors.required;
      }

      return isFormValid;
    },
    submitDocument() {
      const workerId = this.$route.params.id;
      this.attemptToSend = true;

      if (this.validateForm()) {
        this.$store
          .dispatch("personalEmployee/medicalDocuments/addAnalyseToWorker", {
            workerId,
            analyseId: this.selectedAnalyse.value,
            analyseDate: this.dateOfAnalyse,
            analyseComment: this.analyseComment,
            files: this.formDataFiles,
          })
          .then(() => {
            this.$emit("submitted");
            this.closeModal();
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.svg-wrapper {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  pointer-events: none;
  left: 0;
  background: rgba(0,0,0,.7);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: .2s ease-in-out;
  &.docsDownload {
    pointer-events: all;
  }
}
.img-wrapper {
  position: relative;
}
.m-document-create-edit {
  position: relative;

  &-close {
    cursor: pointer;
    position: absolute;
    top: 14px;
    right: 12px;
  }

  &-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;
    margin-left: 10px;
    display: flex;
    align-items: flex-start;

    @media (max-width: 480px) {
      flex-direction: column;
    }

    @media screen and (max-width: 700px) {
      font-size: 15px;
    }
  }

  &-content {
    max-height: 636px;
    width: calc(100% + 15px);
    margin-top: 20px;

    &-shadow-top {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      opacity: 0;
      height: 20px;
      width: 100%;
      pointer-events: none;
      -webkit-transition: 0.2s;
      transition: 0.2s;

      &-active {
        opacity: 1;
        background: -webkit-gradient(
          linear,
          left bottom,
          left top,
          color-stop(16.13%, rgba(255, 255, 255, 0)),
          color-stop(100%, #ffffff)
        );
      }
    }

    &-shadow-bottom {
      position: absolute;
      background: transparent;
      bottom: 0;
      left: 0;
      height: 30px;
      width: 100%;
      opacity: 0;
      pointer-events: none;
      -webkit-transition: 0.2s;
      transition: 0.2s;

      &-active {
        opacity: 1;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 16.13%, #ffffff 100%);
      }
    }

    @media screen and (max-width: 700px) {
      width: calc(100% + 10px);
      max-height: calc(100vh - 120px);
    }

    &-overflow {
      overflow-y: auto;
    }

    &::-webkit-scrollbar {
      width: 4px;
      height: 100%;
    }

    &::-webkit-scrollbar-thumb {
      background: $color-secondary;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background: $color-border-alt;
    }

    &-select {
      margin: 0 15px 27px 10px;

      @media screen and (max-width: 700px) {
        margin: 0 10px 0 10px;
      }

      &-required {
        padding-bottom: 20px;
      }
    }

    &-date {
      margin: 0 15px 27px 10px;
      max-width: 110px;

      @media screen and (max-width: 700px) {
        margin: 27px 10px 0 10px;
      }

      &-required {
        padding-bottom: 20px;
      }

      ::v-deep & .c-input-required_active {
        bottom: -27px;
      }

      ::v-deep & .c-input-required-text {
        white-space: normal;
      }
    }

    &-date.resend {
      @media screen and (max-width: 700px) {
        margin: 0 10px 0 10px;
      }
    }

    &-textarea {
      margin: 0 15px 28px 10px;

      @media screen and (max-width: 700px) {
        margin: 28px 10px 0 10px;
      }

      ::v-deep .c-input-action_clear {
        margin-top: 0 !important;
      }
    }

    &-photos {
      margin: 30px 0 0 10px;
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;

      @media screen and (max-width: 700px) {
        width: calc(100% + 5px);
      }

      &-item {
        display: flex;
        width: 154px;
        margin: 0 12px 25px 0;
        -webkit-animation: fadeIn 1s;
        animation: fadeIn 1s;

        @media screen and (max-width: 700px) {
          margin: 0 12px 30px 0;
          width: 132px;
        }

        &-container {
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          border: 1px solid #dfe4ef;
          border-radius: 6px;
          box-sizing: border-box;
          width: 136px;
          height: 102px;
          position: relative;
          &:hover {
            .svg-wrapper {
              opacity: 1;
            }
          }
          &-cursor-default {
            cursor: default !important;
          }

          @media screen and (max-width: 700px) {
            width: 108px;
            height: 81px;
          }
        }

        &-photo {
          width: 136px;
          object-fit: cover;
          height: 102px;
          border: 1px solid #dfe4ef;
          box-sizing: border-box;
          border-radius: 6px;

          @media screen and (max-width: 700px) {
            width: 108px;
            height: 81px;
          }
        }

        &-name {
          margin-top: 7px;
          text-align: center;
          font-weight: 500;
          font-size: 12px;
          max-width: 136px;
          line-height: 108%;
          padding: 0 0 3px 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          @media screen and (max-width: 700px) {
            max-width: 108px;
          }
        }

        &-trash {
          margin-left: 3px;
        }
      }

      &-error-message {
        display: flex;
        align-items: center;
        margin-left: 13px;
        margin-top: 8px;

        &-text {
          font-size: 11px;
          color: #ff238d;
          margin-left: 10px;
          margin-top: 1px;
        }
      }
    }

    &-add-photo {
      margin: 30px 0 10px 10px;

      &-required {
        border: solid 1px #ff238d;
      }

      &-photos-not-empty {
        margin-top: -5px;

        @media screen and (max-width: 700px) {
          margin-top: -10px;
          margin-bottom: 60px;
        }
      }
    }
  }

  &-buttons {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    @media screen and (max-width: 700px) {
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
    }

    &-cancel {
      @media screen and (max-width: 700px) {
        width: 50%;
        border-radius: 0;
        border-bottom: none;
        border-left: none;
        background: #ffffff;
      }
    }

    &-submit {
      margin-left: 10px;
      @media screen and (max-width: 700px) {
        width: 50%;
        margin-left: 0;
        border-radius: 0;
      }
    }
  }
}

@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.75s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.updating-analyse-label {
  font-weight: 400;
  display: block;
  @media (min-width: 480px) {
    margin-left: 10px;
    display: inline;
  }
}
</style>

<style lang="scss">
.viewer-slider-create-edit-document {
  .viewer-prev,
  .viewer-next {
    display: block !important;
  }
}
.c-input-required-text {
  white-space: nowrap !important;
}
</style>
